import React from "react";

import { Grid, Skeleton as MUISkeleton } from "@mui/material";
import Panel from "components/elements/Panel";

const Skeleton: React.FC = () => {
  return (
    <Panel sx={{ overflow: "hidden", p: 4 }}>
      <Grid container spacing={{ xs: 1, sm: 3 }}>
        <Grid item xs={12} lg={6}>
          <MUISkeleton variant="rectangular" width="100%" height={40}  sx={{ borderRadius: 2 }} />
        </Grid>
        <Grid item xs={12} lg={6} display="flex" alignItems="center">
          <MUISkeleton variant="rectangular" width="100%" height={40}  sx={{ borderRadius: 2 }} />
        </Grid>
      </Grid>
      <Grid container spacing={{ xs: 1, sm: 3 }} pt={2}>
        <Grid item xs={12} lg={6}>
          <MUISkeleton variant="rectangular" width="100%" height={120}  sx={{ borderRadius: 2 }} />
        </Grid>
        <Grid item xs={12} lg={6}>
          <MUISkeleton variant="rectangular" width="100%" height={120}  sx={{ borderRadius: 2 }} />
        </Grid>
      </Grid>
    </Panel>
  );
};

export default Skeleton;
